import {AfterViewInit, Component, ElementRef, Input, inject, OnInit, output, viewChild, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {FocusInputService} from "../../../services/ui/focus-input.service";
import {NgClass} from '@angular/common';

@Component({
	selector: 'app-text-input',
	templateUrl: './text-input.component.html',
	styleUrls: ['./text-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass, ReactiveFormsModule]
})
export class TextInputComponent implements OnInit {
	private focusInputService = inject(FocusInputService);

	@Input() input: FormControl;
	@Input() error = false;
	@Input() warning = false;
	@Input() type: 'text' | 'password' | 'email' | 'number' | 'tel' | 'url' | 'search' = 'text';
	@Input() leftBorder = true;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() panelClass: string;
	@Input() disabled = false;
	@Input() fromSearch = false;
	@Input() readonly = false;

	readonly blur = output<void>();
	readonly enter = output<void>();

	readonly inputElement = viewChild.required<ElementRef>('inputElement');

	ngOnInit() {
		if (this.fromSearch) {
			this.focusInputService.getFocusMessage().subscribe(() => {
				if (!this.input.disabled)
					this.inputElement().nativeElement.focus();
			});
		}
	}
}
